import { CancellationPolicyTag, TextKey } from '@mews-distributor/common';
import { LocalizedText } from '@mews/framework/localization';
import { Tag } from '@optimus-web/core';

interface CancellationPolicySimpleTagProps {
    cancellationPolicyTag: CancellationPolicyTag;
}

export const CancellationPolicySimpleTag = ({ cancellationPolicyTag }: CancellationPolicySimpleTagProps) => {
    switch (cancellationPolicyTag) {
        case CancellationPolicyTag.FreeCancellation:
            return (
                <Tag variant="success">
                    <LocalizedText textKey={TextKey.FreeCancellation} />
                </Tag>
            );
        case CancellationPolicyTag.PartiallyRefundable:
            return (
                <Tag variant="primary">
                    <LocalizedText textKey={TextKey.PartiallyRefundable} />
                </Tag>
            );
        case CancellationPolicyTag.NonRefundable:
        default:
            return (
                <Tag variant="primary">
                    <LocalizedText textKey={TextKey.NonRefundable} />
                </Tag>
            );
    }
};
